export default "__VITE_ASSET__471ad2b9__"